import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { notify } from '@/lib/notify';
import { forwardersApi } from '@/features/forwarders/api';
import { apiErrorMessage } from '@/api/errors';
import type { ForwarderListParams } from '@/features/forwarders/types';
import type { ForwarderFormValues } from '@/features/forwarders/schema';

const keys = { all: ['forwarders'] as const, list: (p: ForwarderListParams) => ['forwarders', 'list', p] as const };
export const useForwardersList = (p: ForwarderListParams) =>
  useQuery({ queryKey: keys.list(p), queryFn: () => forwardersApi.list(p), placeholderData: (x) => x });

export function useCreateForwarder() {
  const qc = useQueryClient();
  return useMutation({ mutationFn: (b: ForwarderFormValues) => forwardersApi.create(b),
    onSuccess: () => { qc.invalidateQueries({ queryKey: keys.all }); notify.success('Forwarder created'); },
    onError: (e) => notify.error(apiErrorMessage(e, 'Could not create forwarder')) });
}
export function useUpdateForwarder() {
  const qc = useQueryClient();
  return useMutation({ mutationFn: ({ id, body }: { id: string; body: Partial<ForwarderFormValues> }) => forwardersApi.update(id, body),
    onSuccess: () => qc.invalidateQueries({ queryKey: keys.all }),
    onError: (e) => notify.error(apiErrorMessage(e, 'Could not update forwarder')) });
}
export function useDeleteForwarder() {
  const qc = useQueryClient();
  return useMutation({ mutationFn: (id: string) => forwardersApi.remove(id),
    onSuccess: () => { qc.invalidateQueries({ queryKey: keys.all }); notify.success('Forwarder deleted'); },
    onError: (e) => notify.error(apiErrorMessage(e, 'Could not delete forwarder')) });
}
